// DailyUrbenNeeds Theme JS — v15
// Cart logic modelled after PawliSupply proven patterns

// Money Formatter
function formatMoney(cents) {
  return '$' + (parseInt(cents) / 100).toFixed(2);
}

// Cart Count Badge
function updateCartCount(count) {
  var num = parseInt(count) || 0;
  document.querySelectorAll('.cart-count').forEach(function(el) {
    el.textContent = num;
    el.style.display = num > 0 ? 'flex' : 'none';
  });
  var dc = document.getElementById('cart-drawer-count');
  if (dc) dc.textContent = num > 0 ? '(' + num + ')' : '';
}

// Cart Drawer Open
function openCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (drawer) drawer.classList.add('open');
  if (overlay) overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

// Cart Drawer Close
function closeCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (drawer) drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('active');
  document.body.style.overflow = '';
}

// Refresh Cart Drawer Contents (full re-render from server)
function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); })
    .catch(function(err) { console.error('Cart refresh error:', err); });
}

// Render cart drawer from cart object
function renderCartDrawer(cart) {
  var itemsEl = document.getElementById('cart-drawer-items');
  var footerEl = document.getElementById('cart-drawer-footer');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');

  updateCartCount(cart.item_count);
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  if (!cart.items || cart.items.length === 0) {
    if (itemsEl) itemsEl.innerHTML = '<div class="cart-empty-state"><div class="cart-empty-icon">\uD83D\uDED2</div><p>Your cart is empty</p><a href="/collections/all" onclick="closeCartDrawer()" class="btn-shop-now">Shop Now</a></div>';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';

  if (itemsEl) {
    itemsEl.innerHTML = cart.items.map(function(item) {
      var imgSrc = item.image || '';
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cdi-variant">' + item.variant_title + '</div>' : '';
      var qty = parseInt(item.quantity) || 1;
      var safeKey = item.key.replace(/:/g, '_');
      return '<div class="cart-drawer-item" data-key="' + item.key + '" data-unit-price="' + item.price + '">'
        + '<div class="cdi-img">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '" loading="lazy">' : '') + '</div>'
        + '<div class="cdi-info">'
          + '<div class="cdi-title">' + item.title + '</div>'
          + variantLabel
          + '<div class="cdi-bottom">'
            + '<div class="cdi-qty">'
              + '<button class="cdi-qty-btn" data-action="dec" data-key="' + item.key + '" aria-label="Decrease" style="touch-action:manipulation">&#8722;</button>'
              + '<span class="cdi-qty-num" id="dqty-' + safeKey + '">' + qty + '</span>'
              + '<button class="cdi-qty-btn" data-action="inc" data-key="' + item.key + '" aria-label="Increase" style="touch-action:manipulation">+</button>'
            + '</div>'
            + '<div class="cdi-price" id="dprice-' + safeKey + '">' + formatMoney(item.final_line_price) + '</div>'
          + '</div>'
        + '</div>'
        + '<button class="cdi-remove" data-key="' + item.key + '" aria-label="Remove" style="touch-action:manipulation">&#215;</button>'
      + '</div>';
    }).join('');

    bindCartDrawerButtons();
  }
}

// Debounce state for cart drawer
var _drawerTimers = {};
var _drawerPending = {};

function bindCartDrawerButtons() {
  var itemsEl = document.getElementById('cart-drawer-items');
  if (!itemsEl) return;

  itemsEl.querySelectorAll('.cdi-qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var key = this.dataset.key;
      var action = this.dataset.action;
      var safeKey = key.replace(/:/g, '_');
      var numEl = document.getElementById('dqty-' + safeKey);
      var priceEl = document.getElementById('dprice-' + safeKey);
      var itemEl = this.closest('.cart-drawer-item');
      if (!numEl) return;

      // Current qty (use pending if exists, else DOM)
      var current = (_drawerPending[key] !== undefined) ? _drawerPending[key] : (parseInt(numEl.textContent) || 1);
      var newQty = action === 'inc' ? current + 1 : current - 1;

      if (newQty < 1) {
        // Fade item out immediately
        if (itemEl) itemEl.style.opacity = '0.4';
        // Cancel any pending debounce and commit remove immediately
        if (_drawerTimers[key]) { clearTimeout(_drawerTimers[key]); delete _drawerTimers[key]; }
        delete _drawerPending[key];
        _commitDrawerChange(key, 0);
        return;
      }

      // Optimistic: update qty display immediately
      numEl.textContent = newQty;
      _drawerPending[key] = newQty;

      // Optimistic: update line price immediately
      if (priceEl && itemEl) {
        var unitPrice = parseInt(itemEl.dataset.unitPrice) || 0;
        if (unitPrice > 0) priceEl.textContent = formatMoney(unitPrice * newQty);
      }

      // Optimistic: update subtotal immediately
      _updateDrawerSubtotalOptimistic();

      // Debounce API call — 350ms after last tap
      if (_drawerTimers[key]) clearTimeout(_drawerTimers[key]);
      _drawerTimers[key] = setTimeout(function() {
        var finalQty = _drawerPending[key];
        delete _drawerPending[key];
        delete _drawerTimers[key];
        _commitDrawerChange(key, finalQty);
      }, 350);
    });
  });

  itemsEl.querySelectorAll('.cdi-remove').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var key = this.dataset.key;
      var itemEl = this.closest('.cart-drawer-item');
      if (itemEl) itemEl.style.opacity = '0.4';
      if (_drawerTimers[key]) { clearTimeout(_drawerTimers[key]); delete _drawerTimers[key]; }
      delete _drawerPending[key];
      _commitDrawerChange(key, 0);
    });
  });
}

// Recalculate subtotal from current DOM state (optimistic)
function _updateDrawerSubtotalOptimistic() {
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  if (!subtotalEl) return;
  var total = 0;
  document.querySelectorAll('.cart-drawer-item').forEach(function(item) {
    var key = item.dataset.key;
    var safeKey = key.replace(/:/g, '_');
    var unitPrice = parseInt(item.dataset.unitPrice) || 0;
    var qty = (_drawerPending[key] !== undefined) ? _drawerPending[key] : (parseInt((document.getElementById('dqty-' + safeKey) || {}).textContent) || 0);
    total += unitPrice * qty;
  });
  subtotalEl.textContent = formatMoney(total);
}

function _commitDrawerChange(itemKey, newQty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: newQty })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) { renderCartDrawer(cart); })
  .catch(function(err) { console.error('Cart change error:', err); refreshCartDrawer(); });
}

// Legacy wrappers for compatibility
function cartChangeQty(itemKey, newQty) {
  if (newQty < 1) { _commitDrawerChange(itemKey, 0); return; }
  _commitDrawerChange(itemKey, newQty);
}
function cartRemoveItem(itemKey) { _commitDrawerChange(itemKey, 0); }

// Add to Cart from Card / Quick Add
function addToCartFromCard(btn) {
  var variantId = btn.dataset.variantId;
  if (!variantId) return;
  var originalHTML = btn.innerHTML;
  btn.innerHTML = 'Adding...';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(function(res) {
    if (res.ok) {
      btn.innerHTML = '&#10003; Added!';
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
        openCartDrawer();
      });
      setTimeout(function() { btn.innerHTML = originalHTML; btn.disabled = false; }, 2000);
    } else {
      btn.innerHTML = 'Try Again';
      btn.disabled = false;
    }
  })
  .catch(function() { btn.innerHTML = originalHTML; btn.disabled = false; });
}

// Product Page: Quantity Controls (used by main-product.liquid inline script)
var currentQty = 1;

function changeQty(delta) {
  currentQty = Math.max(1, Math.min(99, currentQty + delta));
  var display = document.getElementById('qty-display');
  if (display) display.textContent = currentQty;
  var buyBtn = document.getElementById('buy-now-btn');
  if (buyBtn) {
    try {
      var url = new URL(buyBtn.href, window.location.origin);
      url.searchParams.set('quantity', currentQty);
      buyBtn.href = url.toString();
    } catch(e) {}
  }
}

// Product Page: Variant Selection (legacy — used by older section patterns)
function selectVariant(btn, position, value) {
  btn.closest('.variant-options').querySelectorAll('.variant-btn').forEach(function(b) {
    b.classList.remove('active');
  });
  btn.classList.add('active');
  var label = document.getElementById('selected-' + position);
  if (label) label.textContent = value;
  updateVariantId();
}

function updateVariantId() {
  if (typeof productVariants === 'undefined') return;
  var selected = {};
  document.querySelectorAll('.variant-btn.active').forEach(function(btn) {
    selected[btn.dataset.option] = btn.dataset.value;
  });
  var match = null;
  for (var i = 0; i < productVariants.length; i++) {
    var v = productVariants[i];
    var fits = true;
    for (var j = 0; j < v.options.length; j++) {
      if (selected[j + 1] && selected[j + 1] !== v.options[j]) { fits = false; break; }
    }
    if (fits) { match = v; break; }
  }
  if (match) {
    var addBtn = document.getElementById('add-to-cart-btn');
    if (addBtn) addBtn.dataset.variantId = match.id;
    var buyBtn = document.getElementById('buy-now-btn');
    if (buyBtn) buyBtn.href = '/checkout?variant=' + match.id + '&quantity=' + (currentQty || 1);
    var priceEl = document.getElementById('product-price');
    if (priceEl && match.price) priceEl.textContent = formatMoney(match.price);
    var availEl = document.getElementById('variant-availability');
    if (availEl) {
      availEl.textContent = match.available ? 'In Stock \u2014 Ships in 1\u20132 business days' : 'Out of Stock';
      availEl.style.color = match.available ? '#43a047' : '#e53935';
    }
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.style.opacity = match.available ? '1' : '0.5';
    }
  }
}

// Product Page: Add to Cart
function addToCartProduct() {
  var btn = document.getElementById('add-to-cart-btn');
  if (!btn) return;
  var variantId = btn.dataset.variantId;
  if (!variantId) return;
  var qty = currentQty || 1;
  var originalHTML = btn.innerHTML;
  btn.innerHTML = 'Adding...';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
  })
  .then(function(res) {
    if (res.ok) {
      btn.innerHTML = '&#10003; Added to Cart!';
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
        openCartDrawer();
      });
      setTimeout(function() { btn.innerHTML = originalHTML; btn.disabled = false; }, 2500);
    } else {
      res.json().then(function(errData) {
        btn.innerHTML = errData.description || 'Error \u2014 Try Again';
        btn.disabled = false;
        setTimeout(function() { btn.innerHTML = originalHTML; btn.disabled = false; }, 3000);
      }).catch(function() { btn.innerHTML = originalHTML; btn.disabled = false; });
    }
  })
  .catch(function() { btn.innerHTML = originalHTML; btn.disabled = false; });
}

// Product Gallery Thumbnails (legacy — used by older section patterns)
function switchImage(btn, src) {
  document.querySelectorAll('.thumb-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  var mainImg = document.getElementById('main-img');
  if (mainImg) {
    mainImg.style.opacity = '0.5';
    mainImg.src = src;
    mainImg.onload = function() { mainImg.style.opacity = '1'; };
  }
}

// Init on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  // Hamburger menu
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function() {
      var isOpen = mobileNav.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileNav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
    document.querySelectorAll('.mobile-nav a').forEach(function(a) {
      a.addEventListener('click', function() {
        mobileNav.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // Sticky header shadow
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 20px rgba(0,0,0,0.12)'
        : '0 2px 8px rgba(0,0,0,0.06)';
    }, { passive: true });
  }

  // Load cart count on page load
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      var footer = document.getElementById('cart-drawer-footer');
      if (footer) footer.style.display = cart.item_count > 0 ? 'block' : 'none';
    })
    .catch(function() {});

  // Scroll-in animations
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.feature-card-v2, .review-card-v2, .how-card').forEach(function(el) {
      obs.observe(el);
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (mobileNav) {
          mobileNav.classList.remove('open');
          mobileNav.setAttribute('aria-hidden', 'true');
        }
      }
    });
  });

  // Close cart drawer on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  // Back to Top button
  var btt = document.getElementById('back-to-top');
  if (btt) {
    window.addEventListener('scroll', function() {
      btt.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    btt.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // Scroll-in fade animations for .fade-in-up elements
  if ('IntersectionObserver' in window) {
    var fadeObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          fadeObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.fade-in-up, .feature-card-v2, .review-card-v2, .how-card').forEach(function(el) {
      fadeObs.observe(el);
    });
  }

  // Sticky mobile ATC bar — shows when product buttons scroll out of view
  var stickyBar = document.getElementById('sticky-atc-bar');
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var stickyPrice = document.getElementById('sticky-atc-price');
  var productBtnGroup = document.querySelector('.product-btn-group');
  if (stickyBar && productBtnGroup) {
    // Set price from product price element
    var priceEl = document.getElementById('product-price') || document.getElementById('fp-price');
    if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
    window.addEventListener('scroll', function() {
      var rect = productBtnGroup.getBoundingClientRect();
      var isBelow = rect.bottom < 0;
      stickyBar.classList.toggle('visible', isBelow);
    }, { passive: true });
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var addBtn = document.getElementById('add-to-cart-btn') || document.getElementById('fp-add-btn');
        if (addBtn) addBtn.click();
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }
});
